import React, { useEffect, useState, useMemo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import AuthNavbar from '../components/AuthNavbar/AuthNavbar';
import HomeTitle from '../components/HomeTitle/HomeTitle';
import { useDispatch, useSelector } from 'react-redux';
import Table from "../components/Table/Table";
import { useNavigate } from 'react-router-dom';
import { fetchStudents } from '../hooks/students';
import Select from 'react-select'; // Import react-select
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import axios from 'axios';

function Illnesses() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const { list: items } = useSelector((state) => state.Students);
  const [searchText, setSearchText] = useState("");
  const [optionsState, setOptionsState] = useState([]);
  
  // State for transport/filter dropdown (default to 'all')
  const [transportFilter, setTransportFilter] = useState({ label: "الكل (All)", value: "all" });

  // Transport options for the dropdown
  const transportOptions = [
    { label: "الكل (All)", value: "all" },
    { label: "حافلة مدرسية (School Bus)", value: "school_bus" },
    { label: "باص خاص (Private Bus)", value: "private_bus" },
  ];

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.get(`https://nanosoft.space/taarteb/public/api/grades`, {
          headers: {
            Authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL25hbm9zb2Z0LnRlY2hub2xvZ3kvdGFhcnRlYi9hcGkvdXNlci9hdXRoL2xvZ2luIiwiaWF0IjoxNzYxOTA3NTE2LCJleHAiOjE3OTM0NDM1MTYsIm5iZiI6MTc2MTkwNzUxNiwianRpIjoiWEEyOUY5ZkpkRTR6TjVOSyIsInN1YiI6IjQ5IiwicHJ2IjoiZGRmMmI5ODg5ZTA2MmRkZTkzMmM4YWEwZTEwZjg4MDlkMjY0MmY1YyJ9.YmGuLW0CTDXwzfZq9G5f5LnO34EIx-KkbyxXvR0yjNU`
          }
        });
        setOptionsState(response.data.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    getData();
  }, []);

  useEffect(() => {
    dispatch(fetchStudents());
  }, []);

  const exportToExcel = () => {
    const excelData = filteredData.map((item) => {
      const gradeId = item?.student?.grade_id || item?.grade_id;
      const matchedGrade = optionsState?.find((g) => g?.id == gradeId);

      return {
        ID: item.student ? item.student?.id : item.id,
        Name: item.student ? item.student?.name : item.name,
        Stage: matchedGrade?.category || item?.grade_category || item?.grade?.grade_category?.name || "---",
        Grade: matchedGrade?.name || "---",
        FatherName: item.student ? item.student?.parent?.parent_name : item.parent?.parent_name || "---",
        FatherPhone: item.student ? item.student?.parent_phone : item.parent_phone || "---",
        DoesHeSufferFromAnyIllnesses: item?.chronic_diseases || item?.student?.chronic_diseases || "---",
        ParticularFood: item?.food_allergies || item?.student?.food_allergies || "---",
        OtherNotes: item?.other_notes || item?.student?.other_notes || "---",
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    worksheet["!cols"] = [
      { wch: 8 },   { wch: 25 },  { wch: 20 },  { wch: 20 },  
      { wch: 25 },  { wch: 18 },  { wch: 30 },  { wch: 25 },  
      { wch: 30 },
    ];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Illnesses_Students");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(data, "Illnesses_Students_List.xlsx");
  };

  const result = useMemo(() => {
    const grouped = {};
    items?.student_expenses?.data?.forEach((item) => {
      const studentId = item.student.id;
      if (!grouped[studentId]) {
        grouped[studentId] = {
          student: item.student,
          grade: item?.grade?.name,
          grade_category: item?.grade?.grade_category?.name,
          chronic_diseases: item?.student?.chronic_diseases || item?.chronic_diseases,
          food_allergies: item?.student?.food_allergies || item?.food_allergies,
          other_notes: item?.student?.other_notes || item?.other_notes,
          details: [],
          payments: [],
          amount_due: item.amount_due,
          cumulative_paid: item.cumulative_paid,
          expense_price: item.expense_price,
        };
      }

      grouped[studentId].payments.push({
        amount_paid: item.amount_paid,
        created_at: item.created_at,
        is_registration_fee: item.is_registration_fee,
        payment_type: item.details?.[0]?.name
      });

      item.details?.forEach((detail) => {
        const exists = grouped[studentId].details.find(d => d.name === detail.name);
        if (!exists) {
          grouped[studentId].details.push({ name: detail.name });
        }
      });
    });

    Object.values(grouped).forEach(student => {
      student.payments.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
      student.payments.reverse();
    });

    return Object.values(grouped);
  }, [items.student_expenses]);

  const headerIterm = [
    currentLocal.home.ID,
    currentLocal.home.namePlaceholder,
    currentLocal.home.Stage,
    currentLocal.home.grade,
    currentLocal.home.fatherName,
    currentLocal.home.phonePlaceholder,
    currentLocal.home.Doeshesufferfromanyillnesses,
    currentLocal.home.particularfood,
    currentLocal.home.Othernotes,
  ];

  const alldata = [...(result || []), ...(items?.recently_created_students || [])];

  // Filter logic for Search and Dropdown Selection
  const filteredData = useMemo(() => {
    return alldata.filter((item) => {
      const name = item.student ? item.student?.name : item?.name;
      const civil = item.student ? item.student?.identity_number : item?.identity_number;
      const phone = item.student ? item.student?.parent_phone : item?.parent_phone;
      const transportVal = item?.chronic_diseases || item?.student?.chronic_diseases || "";

      // Search matching condition
      const matchesSearch = !searchText.trim() || (
        name?.toLowerCase().includes(searchText.toLowerCase()) ||
        civil?.toString().includes(searchText.toLowerCase()) ||
        phone?.toString().includes(searchText.toLowerCase())
      );

      // Transport/Filter dropdown condition
      let matchesTransport = true;
      if (transportFilter?.value === "school_bus") {
        matchesTransport = transportVal === "school_bus" || transportVal === "حافلة مدرسية";
      } else if (transportFilter?.value === "private_bus") {
        matchesTransport = transportVal === "private_bus" || transportVal === "باص خاص";
      }

      return matchesSearch && matchesTransport;
    });
  }, [searchText, alldata, transportFilter]);

  const body = (
    <tbody>
      {filteredData?.map((item) => {
        const gradeId = item?.student?.grade_id || item?.grade_id;

        return (
          <tr key={item.student ? item.student.id : item.id}>
            <td>{item.student ? item?.student?.id : item.id}</td>
            <td style={{ minWidth: "150px" }}>{item.student ? item.student?.name : item?.name}</td>
            <td>{optionsState?.find(g => g?.id === gradeId)?.category || "---"}</td>
            <td>{optionsState?.find(g => g?.id === gradeId)?.name || "-"}</td>
            <td>{item.student ? item.student?.parent?.parent_name : item.parent?.parent_name || "---"}</td>
            <td>{item.student ? item.student?.parent_phone : item.parent_phone || "---"}</td>
            <td>{item?.chronic_diseases || item?.student?.chronic_diseases || "---"}</td>
            <td>{item?.food_allergies || item?.student?.food_allergies || "---"}</td>
            <td>{item?.other_notes || item?.student?.other_notes || "---"}</td>
          </tr>
        );
      })}
    </tbody>
  );

  return (
    <div className="w-100" style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}>
      <Container fluid className="px-4">
        <AuthNavbar />
        <div className="mt-4">
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
            <HomeTitle title={currentLocal.home.students} />
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <input
                className='form-control'
                style={{ width: "220px" }}
                placeholder={currentLocal.home.search}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <button className="btn btn-sm btn-outline-primary" onClick={() => window.print()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
                  <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                  <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                </svg>
              </button>
              <button className="btn btn-sm btn-success" onClick={exportToExcel}>
                {currentLocal.home.download}
              </button>
            </div>
          </div>

          <div id="printable-table" className="table-responsive shadow-sm bg-white rounded">
            <Table
              data={result}
              headerIterm={headerIterm}
              actions={["edit"]}
              body={body}
            />
          </div>
        </div>
      </Container>
    </div>
  );
}

export default Illnesses;